<div class="progress-section">
  <div class="progress-bar-container">
    <div class="progress-bar-fill" [style.width.%]="progressPercentage"></div>
  </div>

  <!-- Step Indicators -->
  <div class="steps-grid">
    <div class="step-item">
      <a
        class="step-circle"
        [class.active]="currentStep === 1"
        [class.past]="currentStep > 1"
        [routerLink]="currentStep > 1 ? '/sales-funnel' : null"
      >
        <svg>
          <use href="assets/icons.svg#geo-marker"></use>
        </svg>
      </a>
      <span class="step-label">Leads</span>
    </div>

    <div class="step-item">
      <a
        class="step-circle"
        [class.active]="currentStep === 2"
        [class.past]="currentStep > 2"
        [routerLink]="currentStep > 2 ? '/package-offer' : null"
      >
        <svg>
          <use href="assets/icons.svg#package"></use>
        </svg>
      </a>
      <span class="step-label">Service</span>
    </div>

    <div class="step-item">
      <a
        class="step-circle"
        [class.active]="currentStep === 3"
        [class.past]="currentStep > 3"
        [routerLink]="currentStep > 3 ? '/customer-details' : null"
      >
        <svg>
          <use href="assets/icons.svg#person"></use>
        </svg>
      </a>
      <span class="step-label">Customer</span>
    </div>

    <div class="step-item">
      <a
        class="step-circle"
        [class.active]="currentStep === 4"
        [class.past]="currentStep > 4"
        [routerLink]="currentStep > 4 ? '/customer-offer' : null"
      >
        <svg>
          <use href="assets/icons.svg#document"></use>
        </svg>
      </a>
      <span class="step-label">Contract</span>
    </div>

    <div class="step-item">
      <a
        class="step-circle"
        [class.active]="currentStep === 5"
        [class.past]="currentStep > 5"
        [routerLink]="currentStep > 5 ? '/order-confirmation' : null"
      >
        <svg>
          <use href="assets/icons.svg#airplane"></use>
        </svg>
      </a>
      <span class="step-label">Submit</span>
    </div>
  </div>
</div>
